'use client';

import { AppBar, Container, Box } from '@mui/material';
import { StyledToolbar } from './StyledComponents';
import Logo from './Logo';
import Navigation from './Navigation';
import UserSection from './UserSection/UserSection';

export default function Header() {
  return (
    <AppBar
      position="sticky"
      elevation={3}
      sx={{
        height: '70px',
        background: 'linear-gradient(90deg, #475569 0%, #64748b 100%)',
        top: 0,
        zIndex: 1100,
        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)'
      }}
    >
      <Container maxWidth={false} sx={{ height: '100%', maxWidth: '1920px', margin: '0 auto' }}>
        <StyledToolbar disableGutters>
          <Box sx={{ display: 'flex', height: '100%' }}>
            <Logo />
            <Navigation />
          </Box>
          <UserSection />
        </StyledToolbar>
      </Container>
    </AppBar>
  );
}